export default __webpack_public_path__ + "static/media/pen.24367a6a.jpg";